import {
  getClientSpacePartnerPaymentExtraTranslated
} from '@app/invitation/invitation-b2b/shared/helpers/ik-card-selectable-icon-item/get-client-space-partner-payment-extra-translated';
import {
  IIkCardSelectableIconItem
} from '@infomaniak/angular-common/src/components/ik-card-selectable-icon-item/ik-card-selectable-icon-item.interfaces';
import { translate } from '@ngneat/transloco';

export function getClientSpacePartnerPaymentMethods(): IIkCardSelectableIconItem[] {
  return [
    {
      icon: 'icon-card-double',
      title: translate('Le partenaire regle les commandes'),
      description: translate('Le partenaire utilisera ses moyens de paiement pour les commandes et renouvellement de vos produits.')
    },
    {
      icon: 'icon-document',
      title: translate('Le partenaire gere la facturation'),
      description: translate('Les factures seront uniquement disponibles sur le compte du partenaire.') + '<br><br>'
        + getClientSpacePartnerPaymentExtraTranslated()
    }
  ];
}
